<div class="info-wrapper {{className}}">
  {{text}}
</div>